<template>
  <div class="container">
    <div class="qrcode">
      <img :src="`https://www.atropin.cn${$route.query.qrcode}`" />
    </div>
    <div class="hint">请使用支付宝扫描完成支付</div>
  </div>
</template>

<script>
import { orderDetail } from "@api/order";
export default {
  name: "qrcode",
  components: {},
  data() {
    return {
      id: this.$route.query.id,
      timeCount: 0,
      paid: 0,
      isPaid: undefined
    };
  },
  methods: {
    getDetail() {
      const id = this.id;
      // if (!id) return this.$dialog.error("订单不存在");
      orderDetail(id)
        .then(res => {
          console.log(res);
          this.paid = res.data.paid;
        })
        .catch(err => {
          this.$dialog.error(err.msg);
          this.$router.go(-1);
        });
    },
    checkPaid() {
      this.isPaid = setInterval(() => {
        this.getDetail();
        console.log(this.paid);
        this.timeCount++;
        if (this.timeCount > 600 && this.paid === 0) {
          clearInterval(this.isPaid);
          this.$dialog.toast("支付已过期，请重新处理");
          setTimeout(() => {
            this.$router.replace({
              path: `/order/detail/${this.$route.query.id}`
            });
          }, 2000);
        }
        if (this.paid !== 0) {
          clearInterval(this.isPaid);
          this.$dialog.success("支付成功，正在处理...");
          setTimeout(() => {
            this.$router.replace({
              path: `/order/detail/${this.$route.query.id}`
            });
          }, 2000);
        }
      }, 1000);
    }
  },
  mounted() {
    this.checkPaid();
  },

  beforeDestroy() {
    clearInterval(this.isPaid);
  },
  destroyed() {
    clearInterval(this.isPaid);
  }
};
</script>

<style scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.qrcode {
  text-align: center;
}
.hint {
  font-size: 24px;
}
</style>
